export const environment = {
  appVersion: require('../../package.json').version + '-dev',
  production: false,
  helpFile:
    'https://help-preview.mysedgwick.com/mySedgwick5-Login/mySedgwick5_LoginHelp.htm',
  QAMode: false,
  AppCompany: '© #YEAR Sedgwick Claims Management Services, Inc.',
  UseLocalCaptcha: false,
  OnetrustCookieConsentKey: 'cd77d875-c162-48c6-86ed-8bbae7dda63d-test',
};
